import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Header token fallback (cookie may be blocked cross-site)
const TOKEN_KEY = "buildflow.token";
export const setToken = (t) => {
  if (t) localStorage.setItem(TOKEN_KEY, t);
  else localStorage.removeItem(TOKEN_KEY);
};
export const getToken = () => localStorage.getItem(TOKEN_KEY);

api.interceptors.request.use((config) => {
  const t = getToken();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

// P9 — API failure monitoring: status + sanitized path only (ids/tokens stripped).
api.interceptors.response.use((r) => r, (err) => {
  try {
    const status = err.response?.status || 0;
    const url = (err.config?.url || "").split("?")[0].replace(/[0-9a-f-]{12,}/gi, ":id");
    import("./analytics").then(({ trackEvent }) =>
      trackEvent("api_error", { detail: `${status} ${url}`.slice(0, 170), once: false }));
  } catch { /* monitoring must never break the app */ }
  return Promise.reject(err);
});

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
